const BONUS_VARIANT_ID =
  window.ShopifyBonusConfig && window.ShopifyBonusConfig.enabled
    ? window.ShopifyBonusConfig.variantId
    : null;

/**
 * Updates a cart item and manages the bonus product based on subscription status.
 * @param {number} line - The line item index (1-based).
 * @param {number} quantity - The new quantity.
 * @param {number|null} sellingPlan - The selling plan ID or null for one-time purchase.
 * @param {boolean} shouldReload - Whether to reload the page after completion.
 */
let isUpdating = false;

/**
 * Updates a cart item and manages the bonus product based on subscription status.
 * @param {number} line - The line item index (1-based).
 * @param {number} quantity - The new quantity.
 * @param {number|null} sellingPlan - The selling plan ID or null for one-time purchase.
 * @param {boolean} shouldReload - Whether to reload the page after completion.
 */
async function updateCartItem(
  line,
  quantity,
  sellingPlan,
  shouldReload = true,
) {
  if (isUpdating) {
    // console.log("Update already in progress, skipping...");
    return;
  }

  isUpdating = true;
  try {
    // console.log(
    //   `Updating line ${line} with quantity ${quantity} and selling plan ${sellingPlan}`,
    // );

    // 1. Update the main item
    const changeResponse = await axios.post("/cart/change.js", {
      line: line,
      quantity: quantity,
      selling_plan: sellingPlan,
    });

    const cart = changeResponse.data;
    await manageBonusProduct(cart);

    // 2. Optional reload
    if (shouldReload) {
      window.location.reload();
    }
  } catch (error) {
    console.error("Error updating cart item:", error);
    if (shouldReload) {
      window.location.reload();
    }
  } finally {
    isUpdating = false;
  }
}

async function handleItemRemove(line, id) {
  if (isUpdating) {
    console.log("Update already in progress, skipping...");
    return;
  }

  isUpdating = true;
  try {
    // 1. Remove the item
    const changeResponse = await axios.post("/cart/change.js", {
      line: line,
      quantity: 0,
    });

    const cart = changeResponse.data;
    if (BONUS_VARIANT_ID === null) return;

    if (id !== BONUS_VARIANT_ID) {
      await manageBonusProduct(cart);
    }

    // 2. Reload
    window.location.reload();
  } catch (error) {
    // console.error("Error removing item:", error);
    window.location.reload();
  } finally {
    isUpdating = false;
  }
}

/**
 * Checks the cart for subscriptions and adds/removes the bonus product accordingly.
 * @param {Object} cart - The current cart object.
 */
async function manageBonusProduct(cart) {
  if (!BONUS_VARIANT_ID) {
    // console.log("Bonus product is disabled or not configured.");
    return;
  }

  const bonusInCart = cart.items.find(
    (item) => item.variant_id === BONUS_VARIANT_ID,
  );
  const hasAnySubscription = cart.items.some(
    (item) => item.selling_plan_allocation,
  );

  const promoWidget = document.getElementById("cart-bonus-promo");
  const drawerPromoWidget = document.getElementById("drawer-bonus-promo");

  if (hasAnySubscription && !bonusInCart) {
    if (promoWidget) promoWidget.classList.remove("hidden");
    if (drawerPromoWidget) drawerPromoWidget.classList.remove("hide");
  } else if (!hasAnySubscription && bonusInCart) {
    if (promoWidget) promoWidget.classList.add("hidden");
    if (drawerPromoWidget) drawerPromoWidget.classList.add("hide");
    // No subscriptions found, auto remove the bonus product
    try {
      const freshCartRes = await axios.get("/cart.js");
      const freshCart = freshCartRes.data;
      const bonusLineIndex =
        freshCart.items.findIndex(
          (item) => item.variant_id === BONUS_VARIANT_ID,
        ) + 1;

      if (bonusLineIndex > 0) {
        await axios.post("/cart/change.js", {
          line: bonusLineIndex,
          quantity: 0,
        });
        window.location.reload();
      }
    } catch (error) {
      console.error("Error removing bonus product:", error);
    }
  } else {
    if (promoWidget) promoWidget.classList.add("hidden");
    if (drawerPromoWidget) drawerPromoWidget.classList.add("hide");
    console.log("Bonus product state is already correct.");
  }
}

// Click event listener to handle claiming the gift
document.addEventListener("click", async function (e) {
  const claimBonusBtn = e.target.closest(".claim-bonus-btn");
  if (claimBonusBtn) {
    e.preventDefault();
    const variantId = parseInt(claimBonusBtn.getAttribute("data-variant-id"));
    if (!variantId) return;

    try {
      claimBonusBtn.disabled = true;
      claimBonusBtn.innerText = "ADDING...";

      await axios.post("/cart/add.js", {
        id: variantId,
        quantity: 1,
      });

      window.location.reload();
    } catch (err) {
      console.error("Error claiming bonus product:", err);
      claimBonusBtn.disabled = false;
      claimBonusBtn.innerText = "CLAIM FREE GIFT";
    }
  }
});

// Export functions to window
window.updateCartItem = updateCartItem;
window.manageBonusProduct = manageBonusProduct;
